import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { createQueryHook } from '@fourthwall/utils/dist/queries'

export const useTiktokShopsQuery = createQueryHook(
  CreatorIntegrationsApiClient.getTiktokPartnerShops,
  {
    queryKey: ['tiktokShops'],
  },
)
